/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>收银机设置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search"> </el-form>
    <div class="modt-box">收银机主页设置</div>
    <!--列表-->
    <el-form status-icon label-width="100px" class="demo-ruleForm">
      <el-form-item label="中央图片" prop="pass">
        <el-upload
          class="upload-demo"
          action
          :before-upload="beforeIndexUpload"
          :on-preview="handleIndexPreview"
          :on-remove="handleIndexRemove"
          :before-remove="beforeIndexRemove"
          :on-change="handleIndexChange"
          :http-request="uploadIndexFile"
          multiple
          limit="1"
          :on-exceed="handleIndexExceed"
          :file-list="fileIndexList"
        >
          <el-button size="small" type="primary" v-loading.fullscreen.lock="fullscreenLoading">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="下方图片" prop="checkPass">
        <el-upload
          class="upload-demo"
          action
          :on-preview="handleGuanGaoPreview"
          :on-remove="handleGuanGaoRemove"
          :before-remove="beforeGuanGaoRemove"
          :on-change="handleGuanGaoChange"
          :http-request="uploadGuanGaoFile"
          multiple
          limit="1"
          :on-exceed="handleGuanGaoExceed"
          :file-list="fileGuanGaoList"
        >
          <el-button size="small" type="primary" v-loading.fullscreen.lock="fullscreenLoading">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="广告跳转链接" prop="age">
        <el-input placeholder="请输入链接" v-model="urlMessage.hLine"></el-input>
        <el-button @click.prevent="addUrl(domain)" type="primary">确认</el-button>
      </el-form-item>
    </el-form>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="50%"
      @click="closeDialog('editForm')"
    >
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="20">
            <el-form-item label="图片">
              <el-input
                size="small"
                v-model="editForm.orderNum"
                auto-complete="off"
                placeholder="订单号"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="名称">
              <el-input
                size="small"
                v-model="editForm.payMethod"
                auto-complete="off"
                placeholder=""
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="成本">
              <el-input
                size="small"
                v-model="editForm.subtract"
                auto-complete="off"
                placeholder="请输入微信子商户"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="售价">
              <el-input
                size="small"
                v-model="editForm.price"
                auto-complete="off"
                placeholder="请输入通知回调"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="会员价">
              <el-input
                size="small"
                v-model="editForm.vipYouHuiPrice"
                auto-complete="off"
                placeholder="请输入加密类型"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="库存">
              <el-input
                size="small"
                v-model="editForm.activityYouHuiPrice"
                auto-complete="off"
                placeholder="请输入商户签名密钥"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="条码">
              <el-input
                size="small"
                v-model="editForm.activityYouHuiPrice"
                auto-complete="off"
                placeholder="请输入商户签名密钥"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="购买商品">
          <el-input
            size="small"
            v-model="editForm.newContent"
            auto-complete="off"
            placeholder="购买的商品"
            disabled
            style="white-space: pre-line"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { OrderList, OrderRefund, OrderDelete } from "../../api/payMG";
import Pagination from "../../components/Pagination";

import {
  getGoodsList,
  getGoodsTypeList,
  getMemberList,
  getBlackList,
  getCashierImg, //获取收银机图片
} from "@/api/api.js";
export default {
  data() {
    return {
      fullscreenLoading:false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "预览",
      date: "",
      year: "",
      month: "",
      day: "",
      goodsStatus: "", //商品类型
      payway: [
        { key: "全部订单", value: 0 },
        { key: "已完成订单", value: 1 },
        { key: "已取消订单", value: 2 },
        { key: "已退款订单", value: 3 },
      ],
      goodsTypeList: [], //商品类型列表
      orderList: "", //订单列表
      phone: "", //会员手机号
      goodsList: [], //商品列表
      token: localStorage.getItem("token"),
      editForm: {
        id: "",
        name: "",
        payType: 1,
        partner: "",
        subMchId: "",
        appid: "",
        notifyUrl: "",
        signType: "",
        partnerKey: "",
        sellerUserId: "",
        certPath: "",
        certPassword: "",
        rsaKey: "",
        token: localStorage.getItem("logintoken"),
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: "",
        orderNo: "",
        transId: "",
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      formData:[],
      fileIndexList: [],
      fileGuanGaoList: [],
      guanGaoUrl:'',//广告链接
      urlMessage: {
        hLine: "",
        storeID: localStorage.getItem("storeId"),
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline);
    // this.getGoodsType();//获取商品类型列表
    this.getData(); //获取商品列表
    console.log(3333);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //获取商品类型列表
    getGoodsType() {
      getGoodsTypeList().then((res) => {
        //改变数组里元素的某个属性
        res.data.forEach((item) => {
          item.key = item.name;
          item.value = item.id;
        });
        //在数组开头添加一个元素
        res.data.unshift({ key: "所有", value: "" });
        this.goodsTypeList = res.data;
      });
    },
    //获取黑名单列表
    getData() {
      this.loading = true;
      getBlackList({}).then((res) => {
        //改变数组里元素的某个属性
        // res.data.records.forEach((item)=>{
        //   item.payMethod = item.payMethod == 0 ? '微信' : '支付宝'
        //   item.orderStatus = item.orderStatus == 1 ? '已完成' : '生成中'
        //   item.newContent = item.content.replace(/\\n/g, '<br>')
        // })
        this.menberList = res.data;
        this.loading = false;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.limit;
        this.pageparm.total = res.data.total;
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = 10;
      // this.getdata(this.formInline)
      this.getData();
    },
    // 搜索事件
    //上传文件的接口
    uploadIndexFile(file) {
      this.formData.append("file", file.file);
    },
    uploadGuanGaoFile(file) {
      this.formData.append("file", file.file);
    },
    //
    handleIndexChange(file, fileList) {
      this.fullscreenLoading = true;
      this.fileIndexList = fileList;
      let formData = new FormData();
      formData.append("file", this.fileIndexList[0].raw); //拿到存在fileList的文件存放到formData中
      this.$axios
        .post(
          this.$api.OurUpLoadUrl+`/device/cashier/uploadIndexImg?storeID=${localStorage.getItem('storeId')}`, // 添加"userName"字段，替换为你所需的用户名,
          formData,
          {
            "Content-Type": "multipart/form-data;charset=utf-8",
            // "userName": this.name // 添加"userName"字段，替换为你所需的用户名
            headers: {
              "Content-Type": "multipart/form-data;charset=utf-8",
              "token":localStorage.getItem('token'),
              "storeId": localStorage.getItem("storeId"),

            },
          }
        )
        .then((res) => {
          console.log(res, "上传成功");
          if (res.data.code == 200) {
            this.$notify({
              title: "成功",
              message: "提交成功",
              type: "success",
              duration: 1000,
            });
            this.fullscreenLoading = false;
            this.closeDialog();
          } else {
            this.$notify({
              title: "失败",
              message: "提交失败",
              type: "error",
              duration: 1000,
            });
            this.fullscreenLoading = false;
          }
        })
    },
    handleGuanGaoChange(file, fileList) {
      this.fullscreenLoading = true;
      this.fileGuanGaoList = fileList;
      let formData = new FormData();
      formData.append("file", this.fileGuanGaoList[0].raw); //拿到存在fileList的文件存放到formData中
      this.$axios
        .post(
          this.$api.OurUpLoadUrl+`/device/cashier/uploadGuanGaoImg?storeID=${localStorage.getItem('storeId')}`, // 添加"userName"字段，替换为你所需的用户名,
          formData,
          {
            "Content-Type": "multipart/form-data;charset=utf-8",
            // "userName": this.name // 添加"userName"字段，替换为你所需的用户名
            headers: {
              "Content-Type": "multipart/form-data;charset=utf-8",
              "token":localStorage.getItem('token'),
              "storeId": localStorage.getItem("storeId"),

            },
          }
        )
        .then((res) => {
          console.log(res, "上传成功");
          if (res.data.code == 200) {
            this.$notify({
              title: "成功",
              message: "提交成功",
              type: "success",
              duration: 1000,
            });
            this.fullscreenLoading = false;
            this.closeDialog();
          } else {
            this.$notify({
              title: "失败",
              message: "提交失败",
              type: "error",
              duration: 1000,
            });
            this.fullscreenLoading = false;
          }
        })
    },
    //上传收银机主页图片之前的钩子
    beforeIndexUpload(file, fileList) {
      console.log(11111);
      console.log(file, fileList);
    },
    //上传收银机主页图片的钩子
    handleIndexPreview(file) {
      console.log(22222);
      console.log(file);
    },

    //添加广告链接
    addUrl(){
      this.$axios
        .post(
          this.$api.OurUpLoadUrl+`/device/cashier/setCashierH`,
          this.urlMessage,
          {

            // "userName": this.name // 添加"userName"字段，替换为你所需的用户名
            headers: {
              "Content-Type": "application/json",
              "token":localStorage.getItem('token'),
              "storeId": localStorage.getItem("storeId"),

            },
          }
        )
        .then((res) => {

          console.log(res, "上传成功");
          if (res.data.code == 200) {
            this.$notify({
              title: "成功",
              message: "提交成功",
              type: "success",
              duration: 1000,
            });
            this.fullscreenLoading = false;
            this.closeDialog();
          } else {
            this.$notify({
              title: "失败",
              message: "提交失败",
              type: "error",
              duration: 1000,
            });
            this.fullscreenLoading = false;
          }
        })
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = row;
      console.log(index, row, "333333");
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          ConfigSave(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "公司保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("支付配置信息保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("支付配置信息删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.el-form-item__content {
  border-bottom: 1px solid #eaecf1 !important;
}

.modt-box {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f0f2f5;
  text-align: center;
  color: #334157;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 24px;
}
</style>







// WEBPACK FOOTER //
// src/views/system/Role.vue